export const config = {
    URL_API: 'http://www.hmfsa.com.ar/api',
    // URL_API: 'http://192.168.0.106/transbianca/api',
}